import { createContext } from "react";
import { IOBlock } from "../sdkStructs";

export interface LoggerContextProps {
  //included: boolean[];
  //setIncluded: (value: boolean[]) => void;

  flagMode: boolean;
  toggleFlagMode: (value: boolean) => void;

  highlightCommands: boolean[];
  setHighlightCommands: (value: boolean[]) => void;

  highlightRequests: boolean[];
  setHighlightRequests: (value: boolean[]) => void;

  selectedIOBlocks: IOBlock[];
  setSelectedIOBlocks: (value: IOBlock[]) => void;

  tokenDisplay: boolean;
  setTokenDisplay: (value: boolean) => void;

  emptyLogger: boolean;
  setEmptyLogger: (value: boolean) => void;
}

export const LoggerContext = createContext<LoggerContextProps>({
  highlightCommands: [],
  setHighlightCommands: () => {},

  highlightRequests: [],
  setHighlightRequests: () => {},

  flagMode: false,
  toggleFlagMode: () => {},

  selectedIOBlocks: [],
  setSelectedIOBlocks: () => {},

  tokenDisplay: true,
  setTokenDisplay: () => {},

  emptyLogger: true,
  setEmptyLogger: () => {},
});
